import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';

class RecaptchaAPI extends ComponentAPI implements Changeable<string> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string>();

  getValue(): string {
    return this.state.response;
  }

  setValue(): void {
    // ??? ¯\_(ツ)_/¯
  }

  setSiteKey(siteKey: string): void {
    this.setState({ siteKey });
  }

  getSiteKey(): string {
    return this.state.siteKey;
  }
}

export default RecaptchaAPI;
